export const ListIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="16"
    fill="none"
    viewBox="0 0 20 16"
    {...props}
  >
    <g stroke="currentColor" strokeWidth="1.25">
      <path d="M6 2h14"></path>
      <path d="M6 8h14"></path>
      <path d="M6 14h14"></path>
      <circle cx="2" cy="2" r="1.375"></circle>
      <circle cx="2" cy="8" r="1.375"></circle>
      <circle cx="2" cy="14" r="1.375"></circle>
    </g>
  </svg>
);
